import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-agent-hub-page',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './agent-hub-page.component.html',
  styleUrl: './agent-hub-page.component.scss'
})
export class AgentHubPageComponent {}
